module.exports = __webpack_public_path__ + "static/item-6-0b447ad2eb4817928718dbf892d05e24.png";